module.exports = {"newsletter":{"title":"Recibe los últimos rankings de JavaScript en tu email cada semana","text":"Date de alta en la newsletter de {link} y recibirás estadísticas exclusivas sobre los proyectos más populares de JavaScript cada semana.","button":"Suscríbete","placeholder":"Tu email"},"view_project":{"twitter":{"text":"En {year}, {name} consiguió {delta} estrellas, llegando a alcanzar el puesto #{ranking} en {category} en GitHub","action":"Tweet"},"months":"E F M A M J J A S O N D","created":"Creado","homepage":"Home"}}


//////////////////
// WEBPACK FOOTER
// ./i18n/common/es.yaml
// module id = 450
// module chunks = 230186691558513